
import React from 'react';
import { NavigationProvider } from '@/components/navigation/NavigationProvider';
import { AppProviders } from '@/context/providers/AppProviders';
import AppRoutes from './AppRoutes';
import { PlatformGuard } from '@/components/platform/PlatformGuard';

function App() {
  return (
    <AppProviders>
      <PlatformGuard>
        <NavigationProvider>
          <div className="min-h-screen bg-background">
            <AppRoutes />
          </div>
        </NavigationProvider>
      </PlatformGuard>
    </AppProviders>
  );
}

export default App;
